module.exports = __webpack_public_path__ + "sunsemweb/img/tbanner.6ac04c3c.png";